import type { ComponentProps, ReactNode } from "react"
import { cn } from "../../lib"
import {
  Field,
  FieldLabel,
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from "../ui"
import FieldDescriptionOrError from "./FieldDescriptionOrError"

type Props = ComponentProps<typeof InputGroupInput> &
  Pick<ComponentProps<typeof Field>, "orientation"> & {
    label?: string
    inputClassName?: string
    icon?: ReactNode
    error?: string | null
    helperText?: string
  }

export default function InputField({
  label,
  inputClassName,
  icon,
  error,
  helperText,
  name,
  value,
  required,
  className,
  placeholder,
  orientation,
  ...props
}: Props) {
  return (
    <Field
      className={className}
      data-invalid={!!error}
      orientation={orientation}
    >
      {label && (
        <FieldLabel
          htmlFor={name}
          className={cn("text-nowrap", required && "after:content-['*']")}
        >
          {label}
        </FieldLabel>
      )}
      <InputGroup>
        <InputGroupInput
          id={name}
          name={name}
          value={value ?? ""}
          className={inputClassName}
          placeholder={
            required && placeholder ? `${placeholder} *` : placeholder
          }
          aria-invalid={!!error}
          {...props}
        />
        {!!icon && <InputGroupAddon align="inline-end">{icon}</InputGroupAddon>}
      </InputGroup>
      <FieldDescriptionOrError description={helperText} error={error} />
    </Field>
  )
}
